import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import { isEmpty } from "lodash";
import URI from 'urijs';

import "./scss/index.scss";
import Color from "@tool/color";
import Header from "@comp/header/index";
import Footer from "@comp/footer/index";
import SimpleFooter from '@comp/simple-footer/index';
import SecondHeader from "@comp/scond-header/index";
import AppLoading from "@con/app-loading";
import AppLogin from "@con/app-login";
import moSkin, { skinInit } from "@store/skin";
import Service from "@service/index";
import { getBaseInfo } from "@store/user";
import moUser from "@store/user";
import moStore, { toggleValue, toggleLoading } from "@store/index";
import moLogin, { toggleLogin } from "@store/login";
import moIndex, {
  initIndex, toggleTip, changeHidden,
} from "./store/index";
import Content from "./content/index";
import Top from "./top/index";
import Sider from "./sider/index";
import MultiIndustry from "./component/multi-industry/index";
import VipTip from "@comp/vip-tip/index";
import BaseCity from "./component/base-city/index";
import moResearch, {
  initIndustryResearch,
} from "./industry-research/store/index";
import moIndicator, { initIndicator } from "./human-indicator/store/index";
import { demandInit } from "./human-demand/store";
import { welfareInit } from "./wealfare-insight/store/wealfare";
import { talentFlowInit } from "./talent-flow/store/portrait";
import { mobilityInit } from "./talent-flow/store/mobility";
import HRService from "@service/hr";

interface IProps {}
interface IState {}

const LoginButton = styled(Button)(() => ({
  width: "100px",
  height: "36px",
  borderRadius: "4px",
  color: Color.fff,
  backgroundColor: moSkin.mainColor,

  "&:hover": {
    color: Color.fff,
    backgroundColor: moSkin.mainColor,
  },
}));

const Index = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const location = useLocation();
  const { partner, mainColor } = moSkin;
  const { isLogin } = moUser;
  const { isVipTip, industry, isHidden } = moIndex;

  // 预初始化
  const preInit = async () => {
    window.scrollTo(0, 0);
    let module = 1;
    if (location.pathname.includes("industry-research")) module = 1;
    else if (location.pathname.includes("human-indicator")) module = 2;
    else if (location.pathname.includes("human-demand")) module = 3;
    else if (location.pathname.includes("wealfare-insight")) module = 4;
    else if (location.pathname.includes("talent-flow")) module = 5;
    initIndex(module);
  };

  const pre = () => {
    const { isLogin } = moUser;
    // console.log("location -- ", location);
    const uri: any = new URI(window.location.href);
    const path: any = uri.query(true);
    let code = path.industryCode || '';
    let industryName: number | string = '';

    changeHidden(!isLogin);
    if(!isLogin){
      toggleValue("isLoading", false);
    }

    if (!code) {
      preInit();
      return;
    }

    Service.info().then((result: any) => {
      if (isEmpty(result)) {
        preInit();
        return;
      }

      result.industry.map((item: any) => {
        item.sub_industries?.map((child: any) => {

          if (child.code.toString() === code.toString()) {
            industryName = child.name;
          }
        });
      });

      HRService.editUserOption({ my_industry: industryName }).then((res: any) => {
        preInit();
      });
    });
  };

  useEffect(() => {
    document.title = '人力核心指标'
    console.log("index init... ", industry.code);
    // console.log('location -- ', location);
    toggleValue("isLoading", true);
    skinInit();
    getBaseInfo(pre);

    // if (location.pathname.includes('human-indicator')) {
    //   // 人力指标
    //   // initIndicator();
    // } else if (location.pathname.includes('industry-research')) {
    //   // 行业研究
    //   // initIndustryResearch();
    // }

    // 如果 loading 一直没有关闭，则5秒后自动关闭
    setTimeout(() => {
      toggleValue("isLoading", false);
    }, 10000);

    return () => {};
  }, [industry.code]);

  useEffect(() => {
    if(!isLogin){
      toggleValue("isLoading", false);
      changeHidden(true);
    }
  }, [partner]);

  const toLogin = () => {
    toggleLogin(true);
  };

  return (
    <section className="index-page_10">
      <Header isOpacity={false} />
      {/* <SecondHeader label="dashboard" /> */}

      {!isHidden ? (
        <section className="index-container_10">
          <section className="container-top_10" />
          <section className="index-content_10">
            <Top />
            <Sider />
            <Content />
          </section>
        </section>
      ) : (
        <section className="box-1001">
          <p className="label-111">请登录后查看</p>
          <LoginButton onClick={toLogin}>去登录</LoginButton>
        </section>
      )}
      {/* <Footer /> */}
      <SimpleFooter />

      <AppLoading />
      <AppLogin onChangeClose={() => {changeHidden(true);toggleValue("isLoading", false);}} />
      <MultiIndustry />
      <BaseCity />
      <VipTip isOpen={isVipTip} onClose={() => toggleTip(false)} />
    </section>
  );
};

export default observer(Index);
